module.exports = __webpack_public_path__ + "img/star4.8c0e6d5f.8c0e6d5f.png";